import Module from '../module';
import jumpFactory from '../../libs/jump/jump';
import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface} from '../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		infoCardBtnMoreId?: string,
		infoCardAreaShortId?: string,
		infoCardAreaExpandedId?: string,
		infoCardAreaExpandedTransitionCls?: string,
		infoCardAreaShortTransitionCls?: string,
		infoCardBtnLessId?: string,
		moduleHomePartnersId?: string,
		headerCls?: string
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

interface ServiceInterface {
	jump?: ReturnType<typeof jumpFactory.create>;
}

class Partners extends Module {

	publicVars: OptionsInterface;
	service: ServiceInterface = {};

	constructor(options: OptionsInterface) {
		super('Home Partners Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		this.service.jump = jumpFactory.create();
		this.service.jump.init();

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderListCutSetup is required');
		} else {
			const sliderListCut = sliderListCutFactory.create();
			sliderListCut.init(this.publicVars.sliderListCutSetup);
		}
	}

	bind() {
		this.msg('bind');

		if(this.publicVars.cssId.infoCardBtnMoreId) {
			const infoCardBtnMoreHtml = document.querySelector(this.publicVars.cssId.infoCardBtnMoreId) as HTMLElement;

			infoCardBtnMoreHtml?.addEventListener('click', () => {
				this.showInfoCard();
			});
		}

		if(this.publicVars.cssId.infoCardBtnLessId) {
			const infoCardBtnLessHtml = document.querySelector(this.publicVars.cssId.infoCardBtnLessId) as HTMLElement;

			infoCardBtnLessHtml?.addEventListener('click', () => {
				this.hideInfoCard();
			});
		}
	}

	showInfoCard() {
		const transitionCls = this.publicVars.cssId.infoCardAreaExpandedTransitionCls;

		if(!this.publicVars.cssId.infoCardAreaShortId
			|| !this.publicVars.cssId.infoCardAreaExpandedId
			|| !transitionCls
		) {
			this.errorMsg('infoCardAreaShortId, infoCardAreaExpandedId, infoCardAreaExpandedTransitionCls are required');
			return;
		}

		const infoCardAreaShortHtml = document.querySelector(this.publicVars.cssId.infoCardAreaShortId) as HTMLElement;
		const infoCardAreaExpandedHtml = document.querySelector(this.publicVars.cssId.infoCardAreaExpandedId) as HTMLElement;

		if(!infoCardAreaShortHtml || !infoCardAreaExpandedHtml) {
			this.errorMsg('infoCardAreaShort or infoCardAreaExpanded not found');
			return
		}

		infoCardAreaShortHtml.style.display = 'none';

		infoCardAreaExpandedHtml.style.cssText = 'display: block; opacity: 0;';

		infoCardAreaExpandedHtml.addEventListener('transitionend', () => {
			infoCardAreaExpandedHtml.style.cssText = 'display: block;';
			infoCardAreaExpandedHtml.classList.remove(transitionCls.substring(1));
		}, { once: true});

		this.centerInfoCard();

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				infoCardAreaExpandedHtml.classList.add(transitionCls.substring(1));
				infoCardAreaExpandedHtml.style.cssText = 'display: block; opacity: 1;';
			});
		});
	}

	hideInfoCard() {

		const transitionCls = this.publicVars.cssId.infoCardAreaExpandedTransitionCls;

		if(!this.publicVars.cssId.infoCardAreaShortId || !this.publicVars.cssId.infoCardAreaExpandedId || !transitionCls) {
			this.errorMsg('infoCardAreaShortId, infoCardAreaExpandedId, infoCardAreaExpandedTransitionCls are required');
			return;
		}

		const infoCardAreaShortHtml = document.querySelector(this.publicVars.cssId.infoCardAreaShortId) as HTMLElement;
		const infoCardAreaExpandedHtml = document.querySelector(this.publicVars.cssId.infoCardAreaExpandedId) as HTMLElement;

		if(!infoCardAreaShortHtml || !infoCardAreaExpandedHtml) {
			this.errorMsg('infoCardAreaShort or infoCardAreaExpanded not found');
			return
		}

		infoCardAreaExpandedHtml.style.display = 'none';

		infoCardAreaShortHtml.style.cssText = 'display: block; opacity: 0;';

		infoCardAreaShortHtml.addEventListener('transitionend', () => {
			infoCardAreaShortHtml.style.cssText = 'display: block;';
			infoCardAreaShortHtml.classList.remove(transitionCls.substring(1));
		}, { once: true});

		this.centerInfoCard();

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				infoCardAreaShortHtml.classList.add(transitionCls.substring(1));
				infoCardAreaShortHtml.style.cssText = 'display: block; opacity: 1;';
			});
		});
	}

	private centerInfoCard() {
		if(!this.publicVars.cssId.moduleHomePartnersId || !this.publicVars.cssId.headerCls) {
			this.errorMsg('moduleHomePartnersId, headerCls are required');
			return;
		}

		if(!this.service.jump) {
			this.errorMsg('jump service is required');
			return;
		}

		const headerHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

		if(!headerHtml) {
			this.errorMsg('headerCls not found');
			return;
		}

		this.service.jump.centerTo(this.publicVars.cssId.moduleHomePartnersId, {
			modifier: -headerHtml.offsetHeight,
			speed: 300
		}, () => {});
	}
}

export default Partners;